"use client";
import { jsx as h } from "react/jsx-runtime";
import { memo as v } from "react";
import m from "../components/Icon/SvgIcon.js";
const r = (o) => /* @__PURE__ */ h(
  m,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ h(
      "path",
      {
        fill: "currentColor",
        d: "M1 21v-5h2v3h3v2zm17 0v-2h3v-3h2v5zM4 18V6h2v12zm3 0V6h1v12zm3 0V6h2v12zm3 0V6h3v12zm4 0V6h1v12zm2 0V6h1v12zM1 8V3h5v2H3v3zm20 0V5h-3V3h5v5z"
      }
    )
  }
), z = v(r);
export {
  z as BarcodeScanner,
  z as default
};
